import React, { useEffect } from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";

import { useForm } from "react-hook-form";
import Loader from "../../components/loader/Loader";
import { useSelector } from "react-redux";
import GeneralPreviewBannerUpload from "../../components/form-components/GeneralPreviewBannerUpload";

function PreviewBanner({
  regionId,
  loadInitialData,
  formData,
  loader,
  setLoader,
}) {
  const platform = useSelector((state) => state.counter?.platform);

  const methods = useForm();
  const { control, setValue } = methods;

  return loader ? (
    <Loader />
  ) : (
    <>
      <h6 className="text-dark mt-2 screen-heading">Banner Upload</h6>
      <Grid
        container
        spacing={2}
        columnSpacing={{ xs: 5 }}
        style={{ display: "flex", justifyContent: "center" }}
      >
        <Grid item xs={6}>
          <GeneralPreviewBannerUpload
            status={formData?.active_status}
            name={"home_general_banner"}
            control={control}
            label={"Preview Banner"}
            setValue={setValue}
            type="text"
            defaultValue={
              platform == "web" ? formData?.web_image_url : formData?.image_url
            }
            loadInitialData={loadInitialData}
            regionId={regionId}
            platform={platform}
          />
        </Grid>
        <Grid item xs={4}>
          <Paper
            sx={{
              p: 3,
              margin: "auto",
              flexGrow: 1,
            }}
          >
            <ul className=" justify-content-around image-upload-instructions">
              <li>Please upload only jpg, jpeg, png.</li>
              <li>File size shall not exceed 300kb</li>
              <li>
                Dimension : {platform == "app" ? "2:1 ratio" : "4:1 ratio"}
              </li>
            </ul>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}

export default PreviewBanner;
